import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{add-body-classes this.peopleCenterBodyClasses}}\n\n{{outlet}}\n",{ moduleName: "sh-www/templates/people-center.hbs" })